<template>
  <div class="mt-10">
    <div class="flex justify-center gap-6 md:gap-10 lg:justify-start">
      <img src="@/icons/html.png" alt="html" class="w-8 h-8 xl:w-12 xl:h-12" />
      <img src="@/icons/css.png" alt="css" class="w-8 h-8 xl:w-12 xl:h-12" />
      <img src="@/icons/javascript.png" alt="js" class="w-8 h-8 xl:w-12 xl:h-12" />
      <img src="@/icons/typescript.png" alt="ts" class="w-8 h-8 xl:w-12 xl:h-12" />
    </div>
    <div class="flex justify-center gap-6 mt-8 md:gap-10 lg:justify-start">
      <img src="@/icons/vue.png" alt="vue" class="w-8 h-8 xl:w-12 xl:h-12" />
      <img src="@/icons/tailwind.png" alt="tailwind" class="w-8 h-8 xl:w-12 xl:h-12" />
      <img src="@/icons/jest.png" alt="testjest" class="w-8 h-8 xl:w-12 xl:h-12" />
      <img src="@/icons/git.png" alt="git" class="w-8 h-8 xl:w-12 xl:h-12" />
    </div>
  </div>
</template>
